<template>
  <div class="strlist">
    <div
      v-for="(item, i) in items"
      :key="i"
      class="strlist-row"
    >
      <textarea
        v-if="multiline"
        v-model="items[i]"
        v-autosize
        class="strlist-textarea"
        :placeholder="placeholder"
        @input="emit"
      />
      <input
        v-else
        v-model="items[i]"
        class="strlist-input"
        :placeholder="placeholder"
        @input="emit"
      >
      <button
        class="strlist-remove"
        title="Remove"
        @click="remove(i)"
      >
        ✕
      </button>
    </div>
    <button
      class="strlist-add"
      @click="add"
    >
      + {{ addLabel }}
    </button>
  </div>
</template>

<script>
import autosize from '../autosize'

export default {
  name: 'StrListEditor',

  directives: { autosize },

  props: {
    value: { type: Array, default: () => [] },
    multiline: { type: Boolean, default: true },
    placeholder: { type: String, default: '' },
    addLabel: { type: String, default: 'Add item' }
  },

  data () {
    return { items: Array.isArray(this.value) ? this.value.slice() : [] }
  },

  watch: {
    value (v) {
      // Resync when the parent swaps in a different list (e.g. switching agent).
      this.items = Array.isArray(v) ? v.slice() : []
    }
  },

  methods: {
    emit () {
      this.$emit('input', this.items.slice())
    },
    add () {
      this.items.push('')
      this.emit()
    },
    remove (i) {
      this.items.splice(i, 1)
      this.emit()
    }
  }
}
</script>

<style scoped>
.strlist-row {
  display: flex;
  gap: 0.6rem;
  margin-bottom: 0.6rem;
  align-items: flex-start;
}
.strlist-textarea, .strlist-input {
  flex: 1;
  min-width: 0;
  border: 1px solid #d5ddd8;
  border-radius: 6px;
  padding: 0.7rem 0.9rem;
  font-size: 1.3rem;
  font-family: inherit;
  color: #2b3a33;
  background: #fff;
  box-sizing: border-box;
}
.strlist-textarea {
  overflow: hidden;
  resize: none;
  min-height: 3.4rem;
  line-height: 1.5;
}
.strlist-textarea:focus, .strlist-input:focus {
  outline: none;
  border-color: #46634f;
}
.strlist-remove {
  border: none;
  background: #f3f6f4;
  color: #8a9a90;
  border-radius: 4px;
  width: 3rem;
  height: 3.4rem;
  cursor: pointer;
  flex-shrink: 0;
}
.strlist-remove:hover {
  background: #fdecea;
  color: #c0392b;
}
.strlist-add {
  border: 1px dashed #b7c4cd;
  background: none;
  color: #46634f;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  cursor: pointer;
}
.strlist-add:hover {
  background: #f1ffe6;
  border-color: #46634f;
}
</style>
